import { inject, Injectable } from '@angular/core';
import { selectSessionId, setSessionId } from '@conversational/chat-store';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root',
})
export class ConversationalChatPersistenceService {
  readonly #store = inject(Store);
  readonly #storage = localStorage;

  /* Redux Store */

  readonly #sessionIdSignal = this.#store.selectSignal(selectSessionId);
  get sessionId() {
    return this.#sessionIdSignal();
  }

  setSessionId(sessionId: string) {
    this.#store.dispatch(
      setSessionId({ conversationalChatSessionId: sessionId })
    );
  }

  /* localStorage */

  getLastConversationKey(sessionId: string) {
    return (
      Object.keys(this.#storage).find((key) => key.includes(sessionId)) ?? null
    );
  }

  getLastConversation(lastConversationKey: string) {
    const item = this.#storage.getItem(lastConversationKey);
    if (!item) {
      return null;
    }
    return JSON.parse(item);
  }

  getHasAcceptedTerms(): boolean {
    return !!this.#storage.getItem('hasAcceptedTerms');
  }
}
